module.exports = __webpack_public_path__ + "img/20190918171950898.642218a9.jpg";